import { getSVG } from './components/icons-loader.js';
import { Accordions } from './components/accordion.js';
import { isIOS, isAndroid } from './components/user.js'

document.addEventListener("DOMContentLoaded", async function () {
  const accordionButton = new Accordions('.legal-menu-button','.legal-submenu');
  accordionButton.enableButtons();
  accordionButton.legalMenuDefaultBehavior();
  accordionButton.defaultSubMenuBehavior();
  getSVG();
  displayMobileLinks();
  accordionButton.defaultSubMenuBehavior();
});

const displayMobileLinks = () => {
  const mobileLink = document.querySelectorAll('.mobile-show');

  mobileLink.forEach(link => {
    (isIOS && link.classList.contains('ios')) && link.classList.remove('hidden');
    (isAndroid && link.classList.contains('android')) && link.classList.remove('hidden');
  });
}
